import { render, staticRenderFns } from "./notifications-alert.vue?vue&type=template&id=75b8ec7e"
import script from "./notifications-alert.vue?vue&type=script&lang=js"
export * from "./notifications-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports